import { Trash2 } from 'lucide-react'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from 'src/hooks/auth'
import { BeneficiaryDataProps } from 'src/pages/pixOptions/components/NewPix/NewPixForm'
import { BeneficiaryDataStep } from 'src/pages/pixOptions/components/NewPix/NewPixForm/BeneficiaryDataStep'
import { PasswordStep } from 'src/pages/pixOptions/components/NewPix/NewPixForm/PasswordStep'
import { SuccessOnTransactionStep } from 'src/pages/pixOptions/components/NewPix/NewPixForm/SuccessOnTrasactionStep'
import { PixFavoretes } from 'src/pages/pixOptions/components/NewPix/NewPixForm/pixFavorite'
import { api } from 'src/services/api'
import { ExtractItem } from 'src/utils/extractDescription'
import { isAxiosError } from 'src/utils/isAxiosError'
import { setAuthToken } from 'src/utils/setAuthToken'
import { showAlertError } from '../alertError'
import { ModalLoader } from '../modalLoader'
import { ModalContainer, ModalContent, ModalRoot } from '../ui/modal'
import './style.css'

interface ContactProps {
  id: string
  contactName: string
  keyPix: string
  keyType: string
}

export function Contacts() {
  const { user, account } = useAuth()
  const token = localStorage.getItem('@stricv2:token')
  const [contacts, setContacts] = useState<ContactProps[]>([])
  const navigation = useNavigate()
  const [formStep, setFormStep] = useState(1)
  const [beneficiaryData, setBeneficiaryData] = useState<BeneficiaryDataProps>(
    {}
  )
  const [amount, setAmount] = useState(0)
  const [isOpen, setIsOpen] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [transaction, setTransaction] = useState<ExtractItem>()

  const navigate = useNavigate()

  const fetchContacts = async () => {
    try {
      let url = `/pix/favorites`
      const { data } = await api.get<ContactProps[]>(url, {
        headers: { Authorization: 'Bearer ' + token },
      })

      setContacts(data)
    } catch (error) {
      console.error('Error fetching contacts:', error)
    }
  }

  const handleDeleteContact = async (id: string) => {
    try {
      let url = `/pix/favorites`
      await api.delete(`${url}/${id}`, {
        headers: { Authorization: 'Bearer ' + token },
      })

      fetchContacts()
    } catch (error) {
      console.error('Error deleting contact:', error)
    }
  }

  const handlePix = async (contato: ContactProps) => {
    setIsOpen(true)
    setIsLoading(true)
    try {
      setAuthToken()
      const response = await api.post('/pix/keys/check', {
        key: contato.keyPix,
        keyType: contato.keyType,
        userId: user.id,
        accountId: account.virtual_account_id,
      })
      setBeneficiaryData({
        name: response?.data?.name,
        key: response?.data?.key,
        account: response?.data?.bank_ispb,
        keyType: contato.keyType,
        endToEndId: response?.data.end2end_id,
        beneficiaryDocument: response?.data?.cpf_cnpj,
      })
    } catch (error) {
      if (isAxiosError(error) && error.response) {
        const errorMessage = (error.response.data as { message: string })
          .message
        showAlertError(errorMessage)
      } else {
        showAlertError('Ocorreu um erro inesperado.')
      }
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    fetchContacts()
  }, [])

  return (
    <div className="bg-white rounded-lg shadow-md w-full p-[3%]">
      <header className="relative mb-6">
        <div className="flex justify-between items-center border-b border-gray-200 pb-[2%]">
          <span className="text-gray-700 title-text">Contatos Frequentes</span>
        </div>
      </header>
      <div className="space-y-[1.5%] height-table overflow-y-auto">
        {contacts.length === 0 ? (
          <div className="text-gray-500">
            <span>Não há nenhum contato cadastrado ainda</span>
          </div>
        ) : (
          contacts.map((contact) => (
            <div
              key={contact.id}
              className="flex items-center justify-between p-[1%] bg-gray-50 rounded-lg"
            >
              <button onClick={() => handlePix(contact)}>
                <p className="p-texte">
                  <span className="font-semibold text-black">
                    {contact.contactName}
                  </span>{' '}
                  - <span className="text-blue-500">{contact.keyType}</span>:{' '}
                  <span className="text-red-500">{contact.keyPix}</span>
                </p>
              </button>
              <Trash2
                className="text-red-500 cursor-pointer trash-icon ml-4 flex-shrink-0"
                size={20}
                onClick={() => handleDeleteContact(contact.id)}
              />
            </div>
          ))
        )}
      </div>
      <ModalRoot open={isOpen} setIsOpen={setIsOpen}>
        <ModalContainer>
          <ModalContent>
            {/* <ModalClose /> */}
            {formStep === 1 ? (
              <>
                {isLoading ? (
                  <ModalLoader />
                ) : (
                  <BeneficiaryDataStep
                    beneficiaryData={beneficiaryData}
                    setAmount={setAmount}
                    nextStep={() => setFormStep(formStep + 1)}
                  />
                )}
              </>
            ) : formStep === 2 ? (
              <PasswordStep
                amount={amount}
                nextStep={() => setFormStep(formStep + 1)}
                beneficiaryData={beneficiaryData}
                setTransaction={setTransaction}
              />
            ) : formStep === 3 ? (
              <SuccessOnTransactionStep
                nextStep={() => {
                  navigate(`/extract?transactionId=${transaction?.id}`)
                }}
              />
            ) : formStep === 4 ? (
              <PixFavoretes beneficiaryData={beneficiaryData} />
            ) : null}
          </ModalContent>
        </ModalContainer>
      </ModalRoot>
    </div>
  )
}
